import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/Menu/NavBar';
import Login from './pages/login/Login';
import Produtos from './pages/Produtos/Produtos';
import Produto from './pages/Produto/Produto';
import Cadastro from './pages/Cadastros/Produto/Produto';
import Equipamento from './pages/Cadastros/Equipamento/Equipamento';
import PecaEnEquipamento from './pages/Cadastros/PecaEnEquipamento/PecaEnEquipamento';
import Categoria from './pages/Cadastros/Categoria-Linha/Categoria';
import ArvoresPecas from './pages/ArvorePecas/ArvoresPecas';
import Entradas from './pages/Registros/Registrar/Entradas/Entradas.jsx';
import Saidas from './pages/Registros/Registrar/Saidas/Saida.jsx';
import HistoricosEntradas from './pages/Registros/Historicos/HistoricosEntradas.jsx';
import HistoricosSaidas from './pages/Registros/Historicos/HistoricosSaidas.jsx';
import { useAuth } from './hook/useAuth';
import ProtectedRoute from './components/AuthRole/AuthRole';
import Funcionarios from './pages/Cadastros/Usuarios/Funcionarios.jsx';
import ArvoreInfo from './pages/ArvorePecas/ArvoreInfo.jsx';
import Compras from './pages/Compras/Compras.jsx';
import { AppThemeProvider } from './contexts/ThemeContext.jsx';
import CadastroCsv from './pages/CadstroCsv/CadastroCsv.jsx';
import { useSelector } from 'react-redux';
import ProdutoEdit from './pages/Cadastros/Produto/ProdutoEdit.jsx';
import AlertEstoque from './pages/AlertEstoque/AlertEstoque.jsx';
import HorasExtras from './pages/Pcm/HorasExtras.jsx';

function App() {
  const { auth, loading, role } = useAuth();
  const { isSuper } = useSelector((state) => state.auth);

  if (loading) {
    return <div>...</div>;
  }
  return (
    <AppThemeProvider>
      <div className={`dark:bg-darkColorBg `}>
        <BrowserRouter>
          <div className="flex h-dvh">
            {auth && <NavBar />}
            <Routes>
              <Route path="/login" element={auth ? <Navigate to="/" /> : <Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm', 'manutencao']}>
                    <Produtos />
                  </ProtectedRoute>
                }
              >
                <Route
                  path=":id/"
                  element={
                    <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm', 'manutencao']}>
                      <Produto />
                    </ProtectedRoute>
                  }
                />
              </Route>

              <Route
                path="/cadastrar/produto/editar/:id"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <ProdutoEdit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cadastrar/produto/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Cadastro />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cadastrar/maquinario/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Equipamento />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cadastrar/equipamento/peca"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <PecaEnEquipamento />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/cadastrar/categoria/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Categoria />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/arvore-peças"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm', 'manutencao']}>
                    <ArvoresPecas />
                  </ProtectedRoute>
                }
              >
                <Route path=":tag/:name" element={<ArvoreInfo />} />
              </Route>

              <Route
                path="/registrar/entradas/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Entradas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/registrar/saidas/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Saidas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/historico/entradas"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <HistoricosEntradas />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/historico/saida/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <HistoricosSaidas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/funcionarios/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Funcionarios />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/compras/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <Compras />
                  </ProtectedRoute>
                }
              />
              {isSuper && (
                <Route
                  path="/cadastroCsv/"
                  element={
                    <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                      <CadastroCsv />
                    </ProtectedRoute>
                  }
                />
              )}
              <Route
                path="/alert/estoque/"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <AlertEstoque />
                  </ProtectedRoute>
                }
              />
                <Route
                path="/pcm/horas_extras"
                element={
                  <ProtectedRoute auth={auth} role={role} allowedRoles={['pcm']}>
                    <HorasExtras />
                  </ProtectedRoute>
                }
              />
              
              {!auth && <Route path="*" element={<Login />} />}
              {auth && <Route path="*" element={<Navigate to="/" />} />}
            </Routes>
          </div>
        </BrowserRouter>
      </div>
    </AppThemeProvider>
  );
}

export default App;
